<template>
  <Modal
    name="REMOVE_GROUP_MODAL"
    :title="$t('mapDrawing.removeGroupModal.title')"
    actions
  >
    <template v-slot:body>
      <p class="body-2">
        {{ $t('mapDrawing.removeGroupModal.message') }}
      </p>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeModal('REMOVE_GROUP_MODAL')"
        :disabled="isLoading"
        elevation="0"
        color="grey"
        large
        text
      >
        {{ $t('mapDrawing.removeGroupModal.cancel') }}
      </v-btn>
      <v-btn
        @click="removeGroupItem"
        :loading="isLoading"
        color="primary"
        elevation="0"
        class="ml-5"
        large
        dark
      >
        {{ $t('mapDrawing.removeGroupModal.remove') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Modal from '@/components/app/Modal'

export default {
  name: 'ModalConfirmRemoveGroup',

  components: {
    Modal,
  },

  props: {
    groupId: {
      type: String,
      required: false,
    },
  },

  computed: {
    ...mapGetters(['isLoading']),
  },

  methods: {
    ...mapActions(['closeModal', 'removeGroup']),

    removeGroupItem() {
      this.removeGroup(this.groupId)
        .then(() => {
          this.closeModal('REMOVE_GROUP_MODAL')
          this.$parent.$parent.refreshMap()
        })
    },
  },
}
</script>
